module.exports = __webpack_public_path__ + "img/Bean-4.79186998.svg";